export { default } from './LogoCard';
